import { COMMAND_CENTER_ROOT } from '../../commandCenterRoutes'
import OliviumSuiteShell from './OliviumSuiteShell'
import GovToaster from './GovToaster'
import UniversalRecordWorkspace from './UniversalRecordWorkspace'
import { useGovernance } from './GovernanceProvider'
import { GOV_MODULE_DEFS, govModulePath, OLV_SUITE_ROOT, type GovModule } from './governanceCards'

export interface GovRecordWorkspaceProps {
  module: GovModule
  recordId: string
  onOpenRecord: (module: GovModule, recordId: string) => void
  onOpenPath: (to: string) => void
  onHome: () => void
  onCopyLink?: (path: string) => void
}

/**
 * GovRecordWorkspace — the shell + Universal Record Workspace + toaster for a
 * single governance record. The breadcrumb resolves the live record title.
 */
export default function GovRecordWorkspace({ module, recordId, onOpenRecord, onOpenPath, onHome, onCopyLink }: GovRecordWorkspaceProps) {
  const gov = useGovernance()
  const def = GOV_MODULE_DEFS[module]
  const rec = gov.record(recordId)

  return (
    <OliviumSuiteShell
      title={rec?.title ?? def.title}
      accent={def.accent}
      honesty={def.honesty}
      breadcrumb={[
        { label: 'Command Center', to: COMMAND_CENTER_ROOT },
        { label: 'Olivium', to: OLV_SUITE_ROOT },
        { label: def.title, to: govModulePath(module) },
        { label: rec?.id ?? recordId },
      ]}
      onHome={onHome}
      onOpenPath={onOpenPath}
    >
      <UniversalRecordWorkspace
        module={module}
        recordId={recordId}
        onBack={() => onOpenPath(govModulePath(module))}
        onOpenRecord={onOpenRecord}
        onCopyLink={onCopyLink}
      />
      <GovToaster />
    </OliviumSuiteShell>
  )
}
